export const iconFontAwesomeMoneyFileInvoice = (
	<i className="fa-solid fa-file-invoice"></i>
);
